import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AwsService {

  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService,
  ) { }

  /*
  ██╗   ██╗██████╗ ██╗      ██████╗  █████╗ ██████╗
  ██║   ██║██╔══██╗██║     ██╔═══██╗██╔══██╗██╔══██╗
  ██║   ██║██████╔╝██║     ██║   ██║███████║██║  ██║
  ██║   ██║██╔═══╝ ██║     ██║   ██║██╔══██║██║  ██║
  ╚██████╔╝██║     ███████╗╚██████╔╝██║  ██║██████╔╝
   ╚═════╝ ╚═╝     ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝

  */
  // region uploadFile
  async uploadFile(
    uploadUrl: string,
    file: Blob,
    contentType: string,
    message: string,
  ): Promise<boolean> {

    let uploaded: boolean = false;

    this.spinnerService.loading = true;
    this.spinnerService.message = message;

    try {

      const arrayBuffer = await file.arrayBuffer();

      const success = await new Promise<boolean>(
        (resolve, reject) => {
          this.http.put(
            uploadUrl,
            arrayBuffer,
            {
              headers: {
                'Content-Type': contentType,
              },
              responseType: 'text',
            }
          ).subscribe({
            next: () => resolve(true),
            error: (error) => {
              const status = error?.status;
              if(status === 200 || status === 201 || status === 204) {
                resolve(true);
              } else {
                reject(error);
              }
            },
          });
        }
      );

      uploaded = success;

    } catch(error) {
      console.log(error);
    } finally {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return uploaded;

  }

}
